export const CHANNEL = 'payorder';
export const APP = 'payorder';
export const GLOBAL_ASSETS_ROUTE = '/global/assets';
export const PROXY_ROUTE = '/ikea';
